import type { ReactNode } from "react"

import { AnimatedList } from "../AnimatedList"
import { Button } from "../Button"
import { Text } from "../Text"
import { GroupContextProvider } from "./context"
import styles from "./Group.module.css"

export interface GroupProps<ITEM> {
  items: ITEM[]
  title?: string
  addItemButtonTitle?: string
  maxItems?: number
  getItemKey: (item: ITEM) => string
  children: (item: ITEM, index: number) => ReactNode
  onAddItem?: () => void
}

export function Group<ITEM>(props: GroupProps<ITEM>) {
  const {
    title,
    items,
    getItemKey,
    addItemButtonTitle,
    maxItems = Number.MAX_SAFE_INTEGER,
    onAddItem,
    children
  } = props

  const canAddItem = items.length < maxItems

  return (
    <GroupContextProvider itemsCount={items.length}>
      <article className={styles.root}>
        <header className={styles.header}>
          <Text component="span" variant="smallBold">
            {title}
          </Text>
        </header>

        <AnimatedList ariaLabel="Group" items={items} getItemKey={getItemKey}>
          {children}
        </AnimatedList>

        <footer className={styles.footer}>
          {canAddItem && (
            <Button
              size="large"
              color="grey"
              startIcon="add"
              onClick={onAddItem}
            >
              {addItemButtonTitle}
            </Button>
          )}
        </footer>
      </article>
    </GroupContextProvider>
  )
}
